import React, { useEffect, useState } from 'react';
const buyers = [{
  name: 'María L.',
  location: 'Buenos Aires'
}, {
  name: 'Carolina S.',
  location: 'Córdoba'
}, {
  name: 'Luciana M.',
  location: 'Rosario'
}, {
  name: 'Valentina R.',
  location: 'Mendoza'
}, {
  name: 'Florencia G.',
  location: 'La Plata'
}, {
  name: 'Agustina P.',
  location: 'San Isidro'
}, {
  name: 'Camila D.',
  location: 'Tucumán'
}, {
  name: 'Paula V.',
  location: 'Mar del Plata'
}];
export function SocialProofNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    // Show first notification after 5 seconds
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    // Hide after 6 seconds
    const hideTimeout = setTimeout(() => {
      setIsVisible(false);
    }, 6000);
    // Show next notification after 15-25 seconds
    const nextTimeout = setTimeout(() => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
    }, 15000 + Math.random() * 10000);
    return () => {
      clearTimeout(hideTimeout);
      clearTimeout(nextTimeout);
    };
  }, [isVisible]);
  const timeAgo = () => {
    const minutes = Math.floor(Math.random() * 10) + 1;
    return `hace ${minutes} min`;
  };
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-500 ease-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-254">
      {/* iOS-style notification */}
      <div className="bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl border border-black/5 p-3 pr-4 max-w-[320px] flex items-center gap-3" data-id="element-255">
        {/* App icon / Product image */}
        <div className="w-12 h-12 rounded-xl overflow-hidden flex-shrink-0 shadow-sm" data-id="element-256">
          <img src="https://cdn.magicpatterns.com/uploads/v75ce9ekmFxzsPd1BEFCko/PRINCIPAL_Y_BONUS.png" alt="30 Cenas Anti-Pelea" className="w-full h-full object-cover" data-id="element-257" />
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0" data-id="element-258">
          {/* Header row */}
          <div className="flex items-center justify-between gap-2 mb-0.5" data-id="element-259">
            <span className="text-xs font-semibold text-[#2E2E2E] uppercase tracking-wide" data-id="element-260">
              Nueva compra
            </span>
            <span className="text-[10px] text-[#2E2E2E]/50" data-id="element-261">{timeAgo()}</span>
          </div>

          {/* Name */}
          <p className="text-sm font-medium text-[#2E2E2E] truncate" data-id="element-262">
            {currentBuyer.name} de {currentBuyer.location}
          </p>

          {/* Product & Price */}
          <p className="text-xs text-[#2E2E2E]/60 truncate" data-id="element-263">
            30 Cenas Anti-Pelea ·{' '}
            <span className="text-[#E0435A] font-semibold" data-id="element-264">$12.999</span>
          </p>
        </div>
      </div>
    </div>;
}